import { render } from "./fastGPaymentModel.vue?vue&type=template&id=a64ddfde"
import script from "./fastGPaymentModel.vue?vue&type=script&lang=js"
export * from "./fastGPaymentModel.vue?vue&type=script&lang=js"

import "./fastGPaymentModel.vue?vue&type=style&index=0&id=a64ddfde&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__